import React from 'react';

type SaveIconProps = {
  size?: number;
  className?: string;
  testId?: string;
  color?: string;
};

export const SaveIcon = ({ size = 16, className, testId, color }: SaveIconProps): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    data-testid={testId}
    aria-hidden="true"
    style={color ? { color } : undefined}
  >
    <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
    <polyline points="17 21 17 13 7 13 7 21" />
    <polyline points="7 3 7 8 15 8" />
  </svg>
);
